import toast from "react-hot-toast";
import { CheckCircle, XCircle } from "lucide-react";

// reusable toast renderer
const renderToast = (t, type, message) => (
  <div
    className={`${
      t.visible ? "animate-enter" : "animate-leave"
    } ${type === "success"?"border border-green-500":"border border-red-500"} max-w-md w-full bg-white  shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
  >
    <div className="flex-1 w-0 p-4">
      <div className="flex items-start">
        <div className="flex-shrink-0 pt-0.5">
          {type === "success" ? (
            <CheckCircle className="h-6 w-6 text-green-500" />
          ) : (
            <XCircle className="h-6 w-6 text-red-500" />
          )}
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
            {type === "success" ? "Login Successful" : "Login Failed"}
          </p>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            {message}
          </p>
        </div>
      </div>
    </div>
    <div className="flex border-l border-gray-200 dark:border-gray-700">
      <button
        onClick={() => toast.dismiss(t.id)}
        className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-blue-600 hover:text-blue-500 focus:outline-none"
      >
        Close
      </button>
    </div>
  </div>
);

// wrapper with success / error methods
const showLoginToast = {
  success: (message) =>
    toast.custom((t) => renderToast(t, "success", message)),
  error: (message) =>
    toast.custom((t) => renderToast(t, "error", message)),
};

export default showLoginToast;
